import { is, Map } from 'immutable';
import { pathSubscription, subscription } from 'nike-re-framejs';

export const betbook$ = pathSubscription(['betbook'], Map());
export const posts$ = subscription(betbook => betbook.getIn(['posts', 'list']), betbook$);
export const initialBetbookPostsLoadingDone$ = subscription(betbook => {
    const pending = betbook.getIn(['posts', 'filter']);
    const offset = betbook.getIn(['posts', 'filter', 'offset']);
    const loaded = betbook.getIn(['posts', 'filter-loaded']);
    return offset || (pending && is(pending, loaded));
}, betbook$);
export const loadingBetbookPostsPending$ = subscription(betbook => {
    const pending = betbook.getIn(['posts', 'filter']);
    const loaded = betbook.getIn(['posts', 'filter-loaded']);
    return pending && !is(pending, loaded);
}, betbook$);

export const errors$ = pathSubscription(['betbook', 'errors']);
export const postDetail$ = pathSubscription(['betbook', 'detail']);
export const newPostBet$ = pathSubscription(['betbook', 'newPost', 'bet']);
export const hasNextPage$ = pathSubscription(['betbook', 'posts', 'hasMore']);
export const offset$ = pathSubscription(['betbook', 'posts', 'filter', 'offset'], 0);
export const scrollPosition$ = pathSubscription(['betbook', 'posts', 'scrollPosition']);
export const comments$ = pathSubscription(['betbook', 'comments', 'messages']);
export const hasMoreComments$ = pathSubscription(['betbook', 'comments', 'hasMore']);
export const customerComment$ = pathSubscription(['betbook', 'comments', 'customerComment']);
export const editCommentId$ = pathSubscription(['betbook', 'comments', 'messages', 'editedCommentId']);
export const commentedCommentId$ = pathSubscription(['betbook', 'comments', 'messages', 'commentedId']);
export const commentById$ = commentId => pathSubscription(['betbook', 'comments', 'messages', 'byId', commentId]);
export const filterByDate$ = pathSubscription(['betbook', 'posts', 'filter', 'byDate']);
export const filterSorting$ = pathSubscription(['betbook', 'posts', 'filter', 'sorting']);
export const filterNickname$ = pathSubscription(['betbook', 'posts', 'filter', 'nickname']);
export const filterPostType$ = pathSubscription(['betbook', 'posts', 'filter', 'type']);
export const topic$ = pathSubscription(['betbook', 'topic']);
export const redactor$ = pathSubscription(['betbook', 'redactor']);
